import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M12.4.734a2.85 2.85 0 0 0-2.022.842l-2.2 2.2a.25.25 0 0 1-.354-.353l2.199-2.2a3.35 3.35 0 0 1 4.754 0 3.35 3.35 0 0 1 0 4.754l-3.524 3.524a3.35 3.35 0 0 1-4.754.002 3.4 3.4 0 0 1-.43-.512.25.25 0 0 1 .413-.282 3 3 0 0 0 .368.437l.003.003a2.85 2.85 0 0 0 4.045 0l3.526-3.526a2.85 2.85 0 0 0 0-4.046h-.001A2.85 2.85 0 0 0 12.4.733M7.125 6.009a2.85 2.85 0 0 0-2.022.842l-3.526 3.526a2.85 2.85 0 0 0 0 4.046 2.85 2.85 0 0 0 4.046 0l2.2-2.2a.25.25 0 0 1 .354.354l-2.2 2.2a3.35 3.35 0 0 1-4.753 0 3.35 3.35 0 0 1 0-4.754l3.524-3.524a3.35 3.35 0 0 1 4.753-.002q.24.234.43.512a.25.25 0 0 1-.412.282 3 3 0 0 0-.368-.437l-.003-.003a2.85 2.85 0 0 0-2.023-.842",
			clipRule: "evenodd"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h16v16H0z" })
	}) })]
});
export default SvgCyberLink;
